<div class="card">
    <div class="card-header">
        <h4>Merchant Mapping</h4>
    </div>
    <div class="card-body m-0">
        <div class="row g-9 mb-8" [formGroup]="merchantMappingForm">
            <div class="row">
                <div class="col-md-6">
                    <label class="col-form-label" for="merchant">
                        <span class="">Merchant</span>
                    </label>
                    <ng-select id="merchant" placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                        formControlName="merchantEmailId" (change)="changeData()">
                        <ng-option value="">Select Merchant</ng-option>
                        <ng-option *ngFor="let item of merchants" value="{{item.emailId}}">
                            {{item.businessName}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <label class="col-form-label" for="acquirer">
                        <span class="">Acquirer</span>
                    </label>
                    <ng-select id="acquirer" placeholder="Select Acquirer" [inputAttrs]="{maxlength: '100'}"
                        formControlName="acquirer" (change)="changeData()">
                        <ng-option value="">Select Acquirer</ng-option>
                        <ng-option *ngFor="let item of acquirerList" [value]="item.key">
                            {{ item.title }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card" *ngIf="currencies.length">
    <div class="card-body" [formGroup]="merchantMappingForm">
        <div class="checkbox-tree">
            <div *ngFor="let item of currencies; let i=index" class="category">
                <mat-checkbox [(ngModel)]="item.selected" (ngModelChange)="changeCurrency(item)"
                    [ngModelOptions]="{standalone: true}" class="category-checkbox">
                    {{ item.key }}
                </mat-checkbox>
                <div *ngIf="item.selected" class="card">
                    <div class="card-body">
                        <div class="subcategory" formArrayName="accountCurrencySet">
                            <div class="row" *ngFor="let controlName of accountCurrencySet.controls; let j = index"
                                [formGroupName]="j" autocomplete="off">
                                <ng-container *ngIf="item.code ===controlName.value.currencyCode">
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="merchantId{{i}}{{j}}">Merchant ID
                                            <span aria-hidden="true" class="symbol required" style="color:red;"
                                                *ngIf="controlName.get('merchantId')?.validator">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="merchantId{{i}}{{j}}"
                                            placeholder="Merchant ID" formControlName="merchantId"
                                            [ngClass]="{'is-invalid': submitted && controlName.get('merchantId')?.errors}"
                                            (keyup)="changeMerchant($event,controlName,'adf5','merchantId')">
                                        <div class="invalid-feedback" style="display: block;"
                                            *ngIf="submitted && controlName.get('merchantId')?.invalid">
                                            <div *ngIf="controlName.get('merchantId')?.errors?.required">
                                                Merchant ID is required.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="txnKey{{i}}{{j}}">Txn Key</label>
                                        <input type="text" class="form-control" id="txnKey{{i}}{{j}}"
                                            placeholder="Txn Key" formControlName="txnKey">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="password{{i}}{{j}}">Password</label>
                                        <input type="text" class="form-control" id="password{{i}}{{j}}"
                                            placeholder="Password" formControlName="password" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf1{{i}}{{j}}">Adf1</label>
                                        <input type="text" class="form-control" id="adf1{{i}}{{j}}" placeholder="Adf1"
                                            formControlName="adf1">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf2{{i}}{{j}}">Adf2</label>
                                        <input type="text" class="form-control" id="adf2{{i}}{{j}}" placeholder="Adf2"
                                            formControlName="adf2">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf3{{i}}{{j}}">Adf3</label>
                                        <input type="text" class="form-control" id="adf3{{i}}{{j}}" placeholder="Adf3"
                                            formControlName="adf3">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf4{{i}}{{j}}">Adf4</label>
                                        <input type="text" class="form-control" id="adf4{{i}}{{j}}" placeholder="Adf4"
                                            formControlName="adf4">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf5{{i}}{{j}}">Adf5
                                            <span aria-hidden="true" class="symbol required" style="color:red;"
                                                *ngIf="controlName.get('adf5')?.validator">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="adf5{{i}}{{j}}" placeholder="Adf5"
                                            formControlName="adf5"
                                            [ngClass]="{'is-invalid': submitted && controlName.get('adf5')?.errors}"
                                            (keyup)="changeMerchant($event,controlName,'merchantId','adf5')">
                                        <div class="invalid-feedback" style="display: block;"
                                            *ngIf="submitted && controlName.get('adf5')?.invalid">
                                            <div *ngIf="controlName.get('adf5')?.errors?.required">
                                                ADF5 is required.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf6{{i}}{{j}}">Adf6</label>
                                        <input type="text" class="form-control" id="adf6{{i}}{{j}}" placeholder="Adf6"
                                            formControlName="adf6">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf7{{i}}{{j}}">Adf7</label>
                                        <input type="text" class="form-control" id="adf7{{i}}{{j}}" placeholder="Adf7"
                                            formControlName="adf7">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf8{{i}}{{j}}">Adf8</label>
                                        <input type="text" class="form-control" id="adf8{{i}}{{j}}" placeholder="Adf8"
                                            formControlName="adf8">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf9{{i}}{{j}}">Adf9</label>
                                        <input type="text" class="form-control" id="adf9{{i}}{{j}}" placeholder="Adf9"
                                            formControlName="adf9">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf10{{i}}{{j}}">Adf10</label>
                                        <input type="text" class="form-control" id="adf10{{i}}{{j}}" placeholder="Adf10"
                                            formControlName="adf10">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="adf11{{i}}{{j}}">Adf11</label>
                                        <input type="text" class="form-control" id="adf11{{i}}{{j}}" placeholder="Adf11"
                                            formControlName="adf11">
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="invalid-feedback mb-3" style="display: block;" *ngIf="submitted && !accountCurrencySet?.length">
                You must add at least one currency set.
            </div>
            <div class="txn-region-class">
                <label class="inner-class">Transaction Region:</label>
                <mat-checkbox class="inner-class" formControlName="international">International</mat-checkbox>
                <mat-checkbox class="inner-class" formControlName="domestic">Domestic</mat-checkbox>
            </div>
            <div style="display: block;" *ngIf="submitted && merchantMappingForm.hasError('atLeastOneSelected')"
                class="invalid-feedback">
                Select At least one Transaction Region!
            </div>
        </div>
    </div>
</div>

<div class="card" *ngIf="mopList.length">
    <div class="card-body">
        <div class="checkbox-tree">
            <div *ngFor="let item of mopList" class="category">
                <mat-checkbox [(ngModel)]="item.selected" (ngModelChange)="getSelectedPaths()"
                    class="category-checkbox">
                    {{ item.name }}
                </mat-checkbox>

                <div *ngIf="item.selected" class="subcategory-container">
                    <div *ngFor="let subCategory of item.subCategories" class="subcategory">
                        <mat-checkbox [(ngModel)]="subCategory.selected" (ngModelChange)="getSelectedPaths()"
                            class="subcategory-checkbox">
                            {{ subCategory.name }}
                        </mat-checkbox>

                        <div *ngIf="subCategory.selected && subCategory.actions" class="action-container">
                            <div *ngFor="let action of subCategory.actions" class="action">
                                <mat-checkbox [(ngModel)]="action.selected" (ngModelChange)="getSelectedPaths()"
                                    class="action-checkbox">
                                    {{ action.name }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: block;" *ngIf="submitted && merchantMappingForm.hasError('atLeastOneTreeSelected')"
                class="invalid-feedback">
                Please Select Payment Type.
            </div>
        </div>
    </div>
</div>

<div class="d-flex mt-3 justify-content-center" *ngIf="mopList.length && currencies.length">
    <button class="btn bg-danger-custom" type="button" (click)="saveMapping()">Save</button>
</div>